import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { TrackingEventsV2 } from '@/analytics/eventsV2';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useSendKimInterrupt = (matterId?: string, subsetId?: string, threadId?: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<void, Error>(
    async () => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
      });

      const response = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/threads/${threadId}/interrupt`,
        fetchConfig,
      );
      if (!response.ok) {
        throw new Error('Interrupting Kim thread failed');
      }
    },
    {
      onSuccess: () => {
        trackCustomEvent(TrackingEventsV2.KimInterrupt, { matterId, subsetId, threadId });
        queryClient.invalidateQueries([QueryEntity.KimMessages, { subsetId, threadId }]);
        queryClient.invalidateQueries([QueryEntity.KimThread, { threadId }]);
      },
      onError: () => {
        toast.error('Failed to interrupt. Please try again.');
      },
    },
  );
};
